import { useSelector } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';
import { getData } from '../../DataAccessLayer';
import { flashcards } from '../../DataAccessLayer/services';
import useResourceDetail from '../common/useResourceDetail';

/**
 * Wraps every route for one deck's own pages (view, study, edit) to own the
 * deck's fetch for as long as any of them is on screen. React Router keeps a
 * layout route mounted as long as any of its children match, so this
 * unmounts when user navigates to any route other than the deck routes.
 */
function DeckLayout() {
  const { deckId } = useParams();
  const courseId = useSelector((state) => state.course.courseId);

  const {
    resource: deck,
    setResource: setDeck,
    isLoading,
    loadError,
  } = useResourceDetail({
    fetch: () => getData(flashcards({ id: deckId, courseId })),
    resourceLabel: 'flashcard deck',
    id: deckId,
  });

  return <Outlet context={{ deck, setDeck, isLoading, loadError }} />;
}

export default DeckLayout;
